var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediainline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empty Screener Room") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "db270fe4-bb39-4645-bb7d-0747ecb98da6",
    "data-name": "Empty Screener Room"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M297.1,273.85a12.9,12.9,0,0,1-12.89,12.9H119.15a12.91,12.91,0,0,1-12.9-12.9V171.07a12.9,12.9,0,0,1,12.9-12.9H284.21a12.89,12.89,0,0,1,12.89,12.9Z",
    style: {
      fill: "#e0e3e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.21,162.17a8.9,8.9,0,0,1,8.89,8.9V273.85a8.9,8.9,0,0,1-8.89,8.9H119.15a8.91,8.91,0,0,1-8.9-8.9V171.07a8.91,8.91,0,0,1,8.9-8.9H284.21m0-4H119.15a12.9,12.9,0,0,0-12.9,12.9V273.85a12.91,12.91,0,0,0,12.9,12.9H284.21a12.9,12.9,0,0,0,12.89-12.9V171.07a12.89,12.89,0,0,0-12.89-12.9Z",
    style: {
      fill: "#c7cdcf"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "182.95 198.02 228.62 222.91 182.95 247.73 182.95 198.02",
    style: {
      fill: "#f9f9f9"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.5,118H104v-5.5a1.5,1.5,0,0,0-3,0V118H95.5a1.5,1.5,0,0,0,0,3H101v5.5a1.5,1.5,0,0,0,3,0V121h5.5a1.5,1.5,0,0,0,0-3Z",
    style: {
      fill: "#c7cdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5,105H231V99.5a1.5,1.5,0,0,0-3,0V105h-5.5a1.5,1.5,0,0,0,0,3H228v5.5a1.5,1.5,0,0,0,3,0V108h5.5a1.5,1.5,0,0,0,0-3Z",
    style: {
      fill: "#c7cdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.5,167H326v-5.5a1.5,1.5,0,0,0-3,0V167h-5.5a1.5,1.5,0,0,0,0,3H323v5.5a1.5,1.5,0,0,0,3,0V170h5.5a1.5,1.5,0,0,0,0-3Z",
    style: {
      fill: "#c7cdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.12,97.12h-3.24V93.88a.88.88,0,0,0-1.76,0v3.24h-3.24a.88.88,0,0,0,0,1.76h3.24v3.24a.88.88,0,0,0,1.76,0V98.88h3.24a.88.88,0,0,0,0-1.76Z",
    style: {
      fill: "#c7cdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.12,138.12h-3.24v-3.24a.88.88,0,0,0-1.76,0v3.24h-3.24a.88.88,0,0,0,0,1.76h3.24v3.24a.88.88,0,0,0,1.76,0v-3.24h3.24a.88.88,0,0,0,0-1.76Z",
    style: {
      fill: "#c7cdcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.12,184.12H76.88v-3.24a.88.88,0,0,0-1.76,0v3.24H71.88a.88.88,0,0,0,0,1.76h3.24v3.24a.88.88,0,0,0,1.76,0v-3.24h3.24a.88.88,0,0,0,0-1.76Z",
    style: {
      fill: "#c7cdcf"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediainline);
export default __webpack_public_path__ + "static/media/media.inline.78234a92.svg";
export { ForwardRef as ReactComponent };